import styled from "styled-components";

const TABLET = "@media (max-width: 992px)";

export const Wrapper = styled.div`
  width: 256px;
  flex-shrink: 0;
  height: 100%;
  background: #ffffff;
  border-right: 1px solid #e6e9ef;
  display: flex;
  flex-direction: column;

  ${TABLET} {
    width: 200px;
  }
`;

export const SearchBox = styled.div`
  height: 69px;
  padding: 16px;
  border-bottom: 1px solid #e6e9ef;
  display: flex;
  align-items: center;
  box-sizing: border-box;

  img {
    width: 16px;
    height: 16px;
    margin-right: -24px;
    margin-left: 12px;
    z-index: 1;
  }

  input {
    width: 100%;
    height: 36px;
    background: #f4f6fb;
    border: none;
    border-radius: 8px;
    padding: 4px 12px 4px 40px;
    font-size: 14px;
    color: #9197a6;
  }
`;

export const Nav = styled.nav`
  flex: 1;
  overflow-y: auto;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const NavItem = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 42px;
  padding: 12px;
  box-sizing: border-box;
  border: none;
  border-radius: 8px;
  background: ${(props) => (props.$active ? "#f4f6fb" : "transparent")};
  cursor: pointer;
  width: 100%;
  text-align: left;

  span {
    font-size: 13px;
    font-weight: ${(props) => (props.$active ? 600 : 400)};
    color: ${(props) => (props.$active ? "#2c3875" : "#767c8f")};
  }
`;

export const NavItemIcon = styled.span`
  position: relative;
  display: inline-flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;

  img {
    display: block;
    width: 18px;
    height: 18px;
  }
`;

export const NavItemIconFallback = styled.span`
  display: inline-flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #eef1f6;
  color: #9aa2b1;
`;

export const Footer = styled.div`
  border-top: 1px solid #e5e7eb;
  padding: 12px;
`;

export const FooterItem = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  width: 100%;
  text-align: left;

  img {
    width: 18px;
    height: 18px;
  }

  span {
    font-size: 13px;
    color: #293142;
  }
`;
